import { Component, input } from '@angular/core';

@Component({
  selector: 'cp-logo',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  isCollapsed = input<boolean>();
}
